module.exports = __webpack_public_path__ + "img/headline.b0c3b550.png";